export const APPOINTMENT_STATUS_VERIFYING = 1;
export const APPOINTMENT_STATUS_CONFIRMED = 2;
export const APPOINTMENT_STATUS_VISITED = 3;
export const APPOINTMENT_STATUS_CANCELLED = 4;
export const APPOINTMENT_STATUS_NO_SHOW = 5;
export const APPOINTMENT_STATUS_VERIFY_FAILED = 6;
export const APPOINTMENT_STATUS_LATE = 7;

export const HEIGHT_ITEM = 12;
export const MAX_START = 7;
export const MIN_END = 20;
export const STEP_TIME = 5;

export const CITYGATE_ID = 587;
export const WHITELIST_DR = [1, 258, 1137, 1150, 1139, 494, 498, 263, 1587, 1690, 1394, 971];
export const WHITELIST_CLINIC = [213, 1, 318, 83, 112, 37, 43, 68, CITYGATE_ID];

export const nricFormatRegex = /^[STFGM]\d{7}[A-Z]$/;
